module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_bci_Min.5b3d3f44.svg";